module.exports = __webpack_public_path__ + "static/media/ebay.d33ad0d4.svg";